import React, { useContext, useEffect, useState } from 'react';
import './Doc.css';
import { FirebaseContext } from '../../context/firebase';
import ModelHomes from './modelHomes/ModelHomes';
import Pricing from '../documentClient/pricing/Pricing';
import StepBar from './StepBar';
import { useHistory, useLocation } from 'react-router';
import { useStep } from 'react-hooks-helper';
import Dates from './dates/Dates';
import Client from './client/Client';
import Lawyer from './lawyer/Lawyer';
import Finances from './finances/Finances';
import Spinner from '../layout/spinner/Spinner';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import * as PROJECT_CODE from '../../constants/projectCode';
import { GetDocumentRef } from './SaveAndLoadDocument';
import Lots from '../document/lots/Lots';
import { GetClientAuthToken } from '../clients/getClientHelloSignAuthToken';
import CoBroker from './coBroker/CoBroker';

function Doc() {
	const { firebase } = useContext(FirebaseContext);
	const [lotList, setLotList] = useState('');
	const [elevationList, setElevationList] = useState([]);
	const [exteriorImgLink, setExteriorImgLink] = useState();
	const [exteriorImage, setExteriorImage] = useState();
	const [pricingDetails, setPricingDetails] = useState([]);
	const [elevationPriceSum, setElevationPriceSum] = useState();
	const [buildingPriceSum, setBuildingPriceSum] = useState();
	const [lotPriceSum, setLotPriceSum] = useState();
	const [elevationPrice, setElevationPrice] = useState(0);
	const [floorplan, setFloorplan] = useState();
	const [elevationTab, setElevationTab] = useState();
	const [elevationId, setElevationId] = useState();
	const [lotPrice, setLotPrice] = useState(0);
	const [totalUpgradePrice, setTotalUpgradePrice] = useState();
	const [irrevocableDate, setIrrevocableDate] = useState();
	const [closingDate, setClosingDate] = useState();
	const [
		individualSecondPurchaserDetails,
		setIndividualSecondPurchaserDetails,
	] = useState();
	const [individualDetails, setIndividualDetails] = useState();
	const [corporationDetails, setCorporationDetails] = useState();
	const [lawyerDetails, setLawyerDetails] = useState();
	const [coBrokerDetails, setCoBrokerDetails] = useState();
	const [totalMainFloor, setTotalMainFloor] = useState(0);
	const [mortgageDetails, setMortgageDetails] = useState();
	const [expanded, setExpanded] = useState(0);
	const [loading, setLoading] = useState(false);
	const [clientZipCode, setClientZipCode] = useState();
	const [lotActive, setLotActive] = useState();
	const [isCompleted, setIsCompleted] = useState({
		lots: false,
		modelhomes: false,
		pricing: false,
		dates: false,
		client: false,
		lawyer: false,
		coBroker: false,
		finances: false,
	});
	const [disable, setDisable] = useState({
		lots: true,
		modelhomes: true,
		pricing: true,
		dates: true,
		client: true,
		lawyer: true,
		coBroker: true,
		finances: true,
	});
	const [upgradeTotalPrice, setUpgradeTotalPrice] = useState({
		cabinetry: 0,
		countertops: 0,
		doorstrim: 0,
		flooring: 0,
		lighting: 0,
		plumbing: 0,
	});
	const [displayFinal, setDisplayFinal] = useState({
		lots: false,
		modelhomes: false,
		pricing: false,
		dates: false,
		client: false,
		lawyer: false,
		coBroker: false,
		finances: false,
	});
	const location = useLocation();

	useEffect(async () => {
		setLoading(true);
		var clientEmail = location.state.clientEmail;

		console.log('CLient email in useEffect: ' + clientEmail);
		var documentLocationRef;
		await GetDocumentRef(firebase, clientEmail).then((returnedRef) => {
			console.log('FIRST DOCUMENT REFERENCE STRING' + returnedRef.toString());
			documentLocationRef = returnedRef;
			console.log('wfjwsikjfnw');

			documentLocationRef.once('value', (snapshot) => {
				var expandFromClient = location.state?.expand;

				var expandedData = expandFromClient
					? parseInt(expandFromClient)
					: snapshot.val()?.expanded;
				console.log('This is the expandedData ', expandedData);
				if (expandedData === 0) {
					navigation.go(0);
				} else if (expandedData === 1) {
					navigation.go(1);
				} else if (expandedData === 2) {
					navigation.go(2);
				} else if (expandedData === 3) {
					navigation.go(3);
				} else if (expandedData === 4) {
					navigation.go(4);
				} else if (expandedData === 5) {
					navigation.go(5);
				} else if (expandedData === 6) {
					navigation.go(6);
				} else if (expandedData === 7) {
					navigation.go(7);
				}
			});
			setLoading(false);
		});

		if (location.state.from === 'client') {
			console.log('This is the firebase ref: ', window.clientDetailConst);

			firebase
				.database()
				.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
				.off('value', window.clientDetailConst);
		}
	}, []);

	useEffect(() => {
		setLoading(true);
		var lotId = location.state.lotId;
		var previousPath = location.state.from;

		var clientEmail = location.state.clientEmail;
		var documentLocationRef;
		GetDocumentRef(firebase, clientEmail).then((returnedRef) => {
			console.log('DOCUMENT REFERENCE STRING' + returnedRef.toString());
			documentLocationRef = returnedRef;
			var expandFromClient = location.state?.expand;

			console.log('expandFromClient', expandFromClient);

			documentLocationRef.once('value', (snapshot) => {
				//console.log("Get Document json : " + snapshot.val().appCode);
				var isCompletedData = snapshot.val()?.isCompleted;
				var disableData = snapshot.val()?.disable;
				var expandedData = expandFromClient
					? parseInt(expandFromClient)
					: snapshot.val()?.expanded;
				var lotListData = snapshot.val()?.lotList;
				var lotActiveData = snapshot.val()?.lotActive;
				var elevationListData = snapshot.val()?.elevationList;
				var pricingDetailsData = snapshot.val()?.pricingDetails;
				var displayFinalData = snapshot.val()?.displayFinal;
				var totalMainFloorData = snapshot.val()?.totalMainFloor;
				var elevationTabData = snapshot.val()?.elevationTab;
				var elevationPriceSumData = snapshot.val()?.elevationPriceSum;
				var buildingPriceSumData = snapshot.val()?.buildingPriceSum;
				var lotPriceSumData = snapshot.val()?.lotPriceSum;
				var elevationPriceData = snapshot.val()?.elevationPrice;
				var elevationIdData = snapshot.val()?.elevationId;
				var lotPriceData = snapshot.val()?.lotPrice;
				var totalUpgradePriceData = snapshot.val()?.totalUpgradePrice;
				var irrevocableDateData = snapshot.val()?.irrevocableDate;
				var closingDateData = snapshot.val()?.closingDate;
				var individualDetailsData = snapshot.val()?.individualDetails;
				var corporationDetailsData = snapshot.val()?.corporationDetails;
				var lawyerDetailsData = snapshot.val()?.lawyerDetails;
				var coBrokerDetailsData = snapshot.val()?.coBrokerDetails;
				var mortgageDetailsData = snapshot.val()?.mortgageDetails;
				var clientZipCodeData = snapshot.val()?.clientZipCode;
				console.log('irrevocableDate' + irrevocableDateData);
				console.log('closing' + closingDateData);
				console.log('expandedData', expandedData);
				console.log('displayFinalData', displayFinalData);

				if (
					isCompletedData !== undefined ||
					disableData !== undefined ||
					expandedData !== undefined ||
					lotListData !== undefined ||
					lotActiveData !== undefined ||
					elevationListData !== undefined ||
					pricingDetailsData !== undefined ||
					displayFinalData !== undefined ||
					elevationPriceSumData !== undefined ||
					buildingPriceSumData !== undefined ||
					totalMainFloorData !== undefined ||
					elevationTabData !== undefined ||
					lotPriceSumData !== undefined ||
					elevationPriceData !== undefined ||
					elevationIdData !== undefined ||
					lotPriceData !== undefined ||
					totalUpgradePriceData !== undefined ||
					irrevocableDateData !== undefined ||
					closingDateData !== undefined ||
					individualDetailsData !== undefined ||
					corporationDetailsData !== undefined ||
					lawyerDetailsData !== undefined ||
					coBrokerDetailsData !== undefined ||
					mortgageDetailsData !== undefined ||
					clientZipCodeData !== undefined
				) {
					console.log('expanded: ' + expandedData);
					setIsCompleted(isCompletedData);
					setDisable(disableData);
					setExpanded(expandedData);
					setLotList(lotListData);
					setLotActive(lotActiveData);
					setElevationList(elevationListData);
					setPricingDetails(pricingDetailsData);
					setDisplayFinal(displayFinalData);
					setElevationPriceSum(elevationPriceSumData);
					setElevationTab(elevationTabData);
					setTotalMainFloor(totalMainFloor);
					setBuildingPriceSum(buildingPriceSumData);
					setLotPriceSum(lotPriceSumData);
					setElevationPrice(elevationPriceData);
					setElevationId(elevationIdData);
					setLotPrice(lotPriceData);
					setTotalUpgradePrice(totalUpgradePriceData);
					setIrrevocableDate(irrevocableDateData);
					setClosingDate(closingDateData);
					setIndividualDetails(individualDetailsData);
					setCorporationDetails(corporationDetailsData);
					setLawyerDetails(lawyerDetailsData);
					setCoBrokerDetails(coBrokerDetailsData);
					setMortgageDetails(mortgageDetailsData);
					setClientZipCode(clientZipCodeData);
				}
				setLoading(false);
			});
		});

		if (previousPath === 'client' && lotId !== undefined && lotId !== null) {
			console.log('There is a lot [' + lotId + ']');
			var buildingArr = [];
			var priceDetailArr = [];

			var buildingDetails;

			function capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			}

			firebase
				.database()
				.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/' + lotId)
				.once('value', (snapshot) => {
					var availability = snapshot.val().available;

					var buildingRef = snapshot.child('buildings');
					console.log('buildingRef: ' + JSON.stringify(buildingRef));
					buildingRef.forEach((snap) => {
						function numberWithCommas(x) {
							return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
						}

						snap.forEach((building) => {
							buildingDetails = {
								name: capitalizeFirstLetter(building.key),
								buildingLot: lotId,
								price: building.val().priceList,
								sqft: building.val().sqft,
								buildingPrice: numberWithCommas(building.val().buildingPrice),
								soldout: building.val().soldout,
								available: availability,
							};

							buildingArr.push(buildingDetails);
						});
					});

					console.log('buildingDetails: ' + JSON.stringify(buildingDetails));
					setLotList(buildingArr);
				});
		}
	}, []);

	// multi step form
	const steps = [
		{ id: 'lots' },
		{ id: 'modelhomes' },
		{ id: 'pricing' },
		{ id: 'dates' },
		{ id: 'client' },
		{ id: 'lawyer' },
		{ id: 'cobroker' },
		{ id: 'finances' },
	];

	const { step, navigation } = useStep({
		steps,
		initialStep: 0,
	});

	const switchComponent = () => {
		console.log('Expanded: ' + expanded);
		switch (step.id) {
			case 'lots':
				return (
					<Lots
						setLotList={setLotList}
						setBuildingPriceSum={setBuildingPriceSum}
						setLotPriceSum={setLotPriceSum}
						setLotPrice={setLotPrice}
						setIsCompleted={setIsCompleted}
						lotActive={lotActive}
						setLotActive={setLotActive}
					/>
				);

			case 'modelhomes':
				return (
					<ModelHomes
						setLotList={setLotList}
						elevationList={elevationList}
						lotList={lotList}
						exteriorImage={exteriorImage}
						setExteriorImage={setExteriorImage}
						pricingDetails={pricingDetails}
						elevationPriceSum={elevationPriceSum}
						setBuildingPriceSum={setBuildingPriceSum}
						buildingPriceSum={buildingPriceSum}
						setLotPriceSum={setLotPriceSum}
						setElevationPrice={setElevationPrice}
						elevationPrice={elevationPrice}
						setElevationId={setElevationId}
						elevationId={elevationId}
						setLotPrice={setLotPrice}
						lotPrice={lotPrice}
						isCompleted={isCompleted}
						setIsCompleted={setIsCompleted}
						setDisable={setDisable}
						disable={disable}
						floorplan={floorplan}
						setFloorplan={setFloorplan}
						setTotalMainFloor={setTotalMainFloor}
						totalMainFloor={totalMainFloor}
						setElevationTab={setElevationTab}
						elevationTab={elevationTab}
					/>
				);

			case 'pricing':
				return (
					<Pricing
						setTotalUpgradePrice={setTotalUpgradePrice}
						setIsCompleted={setIsCompleted}
						setUpgradeTotalPrice={setUpgradeTotalPrice}
						upgradeTotalPrice={upgradeTotalPrice}
					/>
				);
			case 'dates':
				return (
					<Dates
						irrevocableDate={irrevocableDate}
						setIrrevocableDate={setIrrevocableDate}
						closingDate={closingDate}
						setClosingDate={setClosingDate}
						setIsCompleted={setIsCompleted}
						setDisable={setDisable}
						disable={disable}
					/>
				);
			case 'client':
				return (
					<Client
						setIndividualDetails={setIndividualDetails}
						setCorporationDetails={setCorporationDetails}
						setIndividualSecondPurchaserDetails={
							setIndividualSecondPurchaserDetails
						}
						setIsCompleted={setIsCompleted}
						setDisable={setDisable}
						disable={disable}
						isCompleted={isCompleted}
						setClientZipCode={setClientZipCode}
					/>
				);
			case 'lawyer':
				return (
					<Lawyer
						setLawyerDetails={setLawyerDetails}
						isCompleted={isCompleted}
						setIsCompleted={setIsCompleted}
						setDisable={setDisable}
						disable={disable}
					/>
				);
			case 'cobroker':
				return (
					<CoBroker
						setCoBrokerDetails={setCoBrokerDetails}
						isCompleted={isCompleted}
						setIsCompleted={setIsCompleted}
						setDisable={setDisable}
						disable={disable}
					/>
				);
			case 'finances':
				return (
					<Finances
						irrevocableDate={irrevocableDate}
						mortgageDetails={mortgageDetails}
						setMortgageDetails={setMortgageDetails}
						setIsCompleted={setIsCompleted}
						isCompleted={isCompleted}
						setDisable={setDisable}
						disable={disable}
						elevationList={elevationList}
						elevationPrice={elevationPrice}
						lotPrice={lotPrice}
						upgradeTotalPrice={upgradeTotalPrice}
						setDisplayFinal={setDisplayFinal}
						displayFinal={displayFinal}
					/>
				);

			default:
				break;
		}
	};

	return (
		<>
			{loading && (
				<div className='loading_layout'>
					<CircularProgress
						style={{ position: 'fixed', left: '50%', top: '50%' }}
					/>
				</div>
			)}
			<div className='doc-page'>
				<div className='doc-page-header'>
					<div className='page-title'>
						<h1>Purchase Agreement</h1>
					</div>
					<div className='doc-page-client-name'>
						<div className='header_client_name'>
							{location.state.clientFName}
						</div>
						<div className='header_client_action'>
							<button>Client</button>
						</div>
					</div>
				</div>
				<div className='flex-wrapper'>
					<div className='doc_flow_actions doc_card'>
						<StepBar
							lotList={lotList}
							lotActive={lotActive}
							setLotActive={setLotActive}
							setElevationList={setElevationList}
							setExteriorImgLink={setExteriorImgLink}
							elevationList={elevationList}
							setPricingDetails={setPricingDetails}
							setElevationPriceSum={setElevationPriceSum}
							exteriorImage={exteriorImage}
							setExteriorImage={setExteriorImage}
							elevationPriceSum={elevationPriceSum}
							navigation={navigation}
							buildingPriceSum={buildingPriceSum}
							setBuildingPriceSum={setBuildingPriceSum}
							clientZipCode={clientZipCode}
							setClientZipCode={setClientZipCode}
							setLotPriceSum={setLotPriceSum}
							lotPriceSum={lotPriceSum}
							elevationPrice={elevationPrice}
							elevationId={elevationId}
							lotPrice={lotPrice}
							pricingDetails={pricingDetails}
							totalUpgradePrice={totalUpgradePrice}
							irrevocableDate={irrevocableDate}
							closingDate={closingDate}
							individualDetails={individualDetails}
							individualSecondPurchaserDetails={
								individualSecondPurchaserDetails
							}
							corporationDetails={corporationDetails}
							lawyerDetails={lawyerDetails}
							coBrokerDetails={coBrokerDetails}
							mortgageDetails={mortgageDetails}
							setExpanded={setExpanded}
							expanded={expanded}
							setIsCompleted={setIsCompleted}
							isCompleted={isCompleted}
							setDisable={setDisable}
							disable={disable}
							setLoading={setLoading}
							loading={loading}
							upgradeTotalPrice={upgradeTotalPrice}
							displayFinal={displayFinal}
							setDisplayFinal={setDisplayFinal}
							setElevationId={setElevationId}
						/>
					</div>
					<div className='application_wrapper'>{switchComponent()}</div>
				</div>
			</div>
		</>
	);
}

export default Doc;
